import React, { useEffect, useState } from 'react';
import { Button, Card, Spin } from 'antd';
import { ExpandOutlined } from '@ant-design/icons';
import { getOrderGenieRequest } from '../../services/orderXApi';
import DocumentFilePreview from './DocumentFilePreview';

// Inline, non-modal version of RequestSourcePreviewModal's "Document(s)" tab —
// meant to sit side by side with extracted data/matches in StepReviewMatch, so the
// user can compare the source document against what was extracted without leaving
// the page. `onExpand` opens the full RequestSourcePreviewModal for zoom/email/etc.
const DocumentPreviewPanel = ({ requestId, userId, onExpand }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sourceFiles, setSourceFiles] = useState([]);

  useEffect(() => {
    if (requestId == null || !userId) return undefined;
    let cancelled = false;
    setLoading(true);
    setError('');
    setSourceFiles([]);

    (async () => {
      try {
        const fullRequest = await getOrderGenieRequest(requestId, userId);
        if (cancelled) return;
        const request = fullRequest?.request || {};
        const files = Array.isArray(request.source_files) ? request.source_files : [];
        setSourceFiles(files);
      } catch (err) {
        if (!cancelled) setError(err?.message || 'Unable to load request source.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [requestId, userId]);

  return (
    <Card
      className="shadow-sm border-0"
      title="Input Document"
      size="small"
      extra={onExpand && (
        <Button size="small" icon={<ExpandOutlined />} onClick={onExpand}>Expand</Button>
      )}
    >
      {loading ? (
        <div className="text-center py-4"><Spin /></div>
      ) : error ? (
        <div className="text-danger small">{error}</div>
      ) : sourceFiles.length === 0 ? (
        <div className="text-muted small">No source document is attached to this request.</div>
      ) : (
        <div className="d-flex flex-column gap-3">
          {sourceFiles.map((file) => {
            const key = file.storage_path || file.filename;
            return (
              <div className="border rounded p-2" key={key}>
                <div className="fw-semibold small text-truncate mb-2" title={file.filename}>{file.filename}</div>
                <DocumentFilePreview file={file} maxHeight="65vh" />
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
};

export default DocumentPreviewPanel;
